import React from 'react';
import { Line } from 'react-konva';
import { PolygonProps } from '../types';

interface PolygonControlProps extends PolygonProps {
  isSelected: boolean;
  id: string;
  onSelect: (id: string) => void;
}

const DraggablePolygon: React.FC<PolygonControlProps> = ({
  points,
  onDragStart,
  onDragMove,
  onDragEnd,
  isSelected,
  id,
  onSelect,
}) => {
  const handleClick = (e: any) => {
    onSelect(id);
    e.cancelBubble = true;
  };

  type PolygonStyle = {
    fill: string;
    stroke: string;
    strokeWidth: number;
    shadowColor?: string;
    shadowBlur?: number;
    shadowOffset?: { x: number, y: number };
    shadowOpacity?: number;
  };

  const selectedStyles: PolygonStyle = {
    fill: 'rgba(59, 130, 246, 0.4)',
    stroke: '#2563eb',
    strokeWidth: 3,
    shadowColor: 'rgba(0, 0, 0, 0.3)',
    shadowBlur: 10,
    shadowOffset: { x: 0, y: 2 },
    shadowOpacity: 0.5,
  };

  const defaultStyles: PolygonStyle = {
    fill: 'rgba(96, 165, 250, 0.2)',
    stroke: '#60a5fa',
    strokeWidth: 1.5,
  };

  const styles = isSelected ? selectedStyles : defaultStyles;

  return (
    <Line
      points={points}
      closed
      fill={styles.fill}
      stroke={styles.stroke}
      strokeWidth={styles.strokeWidth}
      shadowColor={styles.shadowColor}
      shadowBlur={styles.shadowBlur}
      shadowOffset={isSelected && styles.shadowOffset ? styles.shadowOffset : { x: 0, y: 0 }}
      shadowOpacity={isSelected ? styles.shadowOpacity : undefined}
      onMouseDown={(e) => {
        if (isSelected) {
          onDragStart(e);
        }
        handleClick(e);
      }}
      onMouseMove={isSelected ? onDragMove : undefined}
      onMouseUp={isSelected ? onDragEnd : undefined}
      onMouseEnter={(e: any) => {
        e.target.getStage().container().style.cursor = 'move';
      }}
      onMouseLeave={(e: any) => {
        e.target.getStage().container().style.cursor = 'default';
        if (isSelected) onDragEnd();
      }}
      onTouchStart={(e) => {
        if (isSelected) {
          onDragStart(e);
        }
        handleClick(e);
      }}
      onTouchMove={isSelected ? onDragMove : undefined}
      onTouchEnd={isSelected ? onDragEnd : undefined}
      onClick={handleClick}
      onTap={handleClick}
    />
  );
};

export default DraggablePolygon;
